<template>
  <div class="page-article-list">
    <div class="page-article-list__left">
      <router-view></router-view>
    </div>
    <div class="page-article-list__right">
      <app-page-box title="我的发布">
        <div class="page-article-list__overview">
          <ul class="page-article-list__meta">
            <li class="page-article-list__meta__item">
              <span class="page-article-list__meta__item__label">已发布</span>
              <span class="page-article-list__meta__item__value">{{ stats.publishArticleCount }}</span>
            </li>
            <li class="page-article-list__meta__item">
              <span class="page-article-list__meta__item__label">待审核</span>
              <span class="page-article-list__meta__item__value">{{ stats.pendingAuditArticleCount }}</span>
            </li>
            <li class="page-article-list__meta__item">
              <span class="page-article-list__meta__item__label">未通过</span>
              <span class="page-article-list__meta__item__value">{{ stats.auditRejectArticleCount }}</span>
            </li>
            <li class="page-article-list__meta__item">
              <span class="page-article-list__meta__item__label">草稿箱</span>
              <span class="page-article-list__meta__item__value">{{ stats.draftArticleCount }}</span>
            </li>
          </ul>
          <el-button size="small" type="primary" style="width: 100%" @click="onPublishBtnClick">发布搜索</el-button>
          <div class="page-article-list__overview__tip">
            <span>智能搜索发布</span>
            <b>{{ stats.aiPublishArticleCount }}</b>
            <span>条，</span>
            <router-link :to="{ name: 'Article' }">查看详情</router-link>
          </div>
        </div>
      </app-page-box>
    </div>
  </div>
</template>

<script>
import AppPageBox from '@/components/AppPageBox'

export default {
  name: 'PageArticleList',
  components: {
    AppPageBox
  },

  data () {
    return {}
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },
    stats () {
      return this.$store.state.article.stats
    }
  },

  created () {
    this.getArticlesStats()
  },

  methods: {
    getArticlesStats () {
      this.$store.dispatch('getArticlesStats', {
        params: { userId: this.user.id }
      })
    },

    onPublishBtnClick () {
      this.$router.push({ name: 'ArticleEdit' })
    }
  }
}
</script>

<style lang="scss">
.page-article-list {
  display: flex;
  min-height: 100%;
  margin-bottom: 15px;

  .el-pagination {
    margin-top: 15px;
    text-align: right;
  }

  &__left {
    flex: 1;
  }

  &__right {
    width: 340px;
    padding-left: 15px;
  }

  &__content {
    height: 100%;
    background-color: #fff;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #eee;
  }

  &__body {
    padding: 15px;
    min-height: 151px;
  }

  &__search {
    width: 300px;
  }

  &__overview {
    &__tip {
      margin-top: 15px;

      > b,
      > a {
        color: $primary-color;
      }
    }
  }

  &__meta {
    display: flex;
    justify-content: space-between;
    padding: 0;
    margin-top: 0;
    margin-bottom: 30px;
    list-style: none;

    &__item {
      flex: 1;
      border-right: 1px solid #eee;
      text-align: center;

      &:last-child {
        border-right: 0;
      }

      &__label,
      &__value {
        display: block;
      }

      &__label {
        color: #999;
        font-size: 14px;
      }

      &__value {
        margin-top: 5px;
        font-size: 16px;
      }
    }
  }
}
</style>
